import React from "react";
import "../../App.css";
import i18next from "../../i18n";
import { Helmet } from "react-helmet-async";
import article_img from "../../images/articles/gjensidige_samarbeid_3.jpg";

function GjensidigeXPER() {
  return (
    <div className="min-h-screen bg-white">
      <Helmet>
        <title>{i18next.t("pages.articles.list.gjensidigeXPER.title")}</title>
        <meta
          name="description"
          content={i18next.t("pages.articles.list.gjensidigeXPER.description")}
        />
        <link
          rel="canonical"
          href="https://xperconsulting.no/artikler/gjensidige-xper-samarbeid"
        />
      </Helmet>
      <div className="container max-w-xl pt-36 justify-start items-center text-main-dark flex flex-col md:flex-row pb-24 md:gap-16">
        <div className="w-full md:w-3/5 text-left">
          <h1 className="text-5xl font-bold text-main-dark mb-4">
            {i18next.t("pages.articles.list.gjensidigeXPER.title")}
          </h1>
          <p className="text-xl mb-2">
            {i18next.t("pages.articles.list.gjensidigeXPER.description")}
          </p>
          <p className="text-lg text-secondary">
            {i18next.t("pages.articles.list.gjensidigeXPER.date")}
          </p>
        </div>
        <img
          src={article_img}
          className="w-full md:w-2/5"
          alt={i18next.t("pages.articles.list.gjensidigeXPER.imageAlt")}
        />
      </div>
      <div className="bg-gray">
        <div className="container max-w-xl text-xl text-left py-24 text-main-dark">
          <div className="max-w-sm">
        

            <blockquote className=" pl-6 pr-6 my-8 ">
              <p className="mb-0 italic font-medium">
                "{i18next.t("pages.articles.list.gjensidigeXPER.sections.quote1.content")}"
              </p>
              <p className="text-sm text-main-dark bg-transparent text-right justify-end mt-4">
                -{i18next.t("pages.articles.list.gjensidigeXPER.sections.quote1.author")}
              </p>
            </blockquote>

            <p>
              {i18next.t("pages.articles.list.gjensidigeXPER.sections.expertise.content")}
            </p>

            <blockquote className=" pl-6 pr-6 my-8 ">
              <p className="mb-0 italic font-medium">
               "{i18next.t("pages.articles.list.gjensidigeXPER.sections.quote2.content")}"
              </p>
              <p className="text-sm text-main-dark bg-transparent text-right justify-end mt-4">
                -{i18next.t("pages.articles.list.gjensidigeXPER.sections.quote2.author")}
              </p>
            </blockquote>

            <h2 className="text-3xl font-bold mt-12 mb-2">
              {i18next.t("pages.articles.list.gjensidigeXPER.sections.accessibility.title")}
            </h2>
            <p>
              {i18next.t("pages.articles.list.gjensidigeXPER.sections.accessibility.content")}
              <a href="/artikler/tilgjengelighetsdirektivet" className=" underline hover:text-contrast-ink">
                {i18next.t("pages.articles.list.gjensidigeXPER.sections.accessibility.link")}
              </a>
              {i18next.t("pages.articles.list.gjensidigeXPER.sections.accessibility.content2")}
            </p>

            <blockquote className=" pl-6 pr-6 my-8 ">
              <p className="mb-0 italic font-medium">
                "{i18next.t("pages.articles.list.gjensidigeXPER.sections.quote3.content")}"
              </p>
              <footer className="text-s text-main-dark bg-transparent text-right justify-end">
                -{i18next.t("pages.articles.list.gjensidigeXPER.sections.quote3.author")}
              </footer>
            </blockquote>
          </div>
        </div>
      </div>
    </div>
  );
}

export default GjensidigeXPER;
